/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MediaItem } from '../../models/media-item';

export interface UserControllerDeleteImage$Params {
  id: number;
}

export function userControllerDeleteImage(http: HttpClient, rootUrl: string, params: UserControllerDeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaItem;
}>> {
  const rb = new RequestBuilder(rootUrl, userControllerDeleteImage.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MediaItem;
      }>;
    })
  );
}

userControllerDeleteImage.PATH = '/user/{id}/picture';
